module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_china.67d10f03.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_china.png
// module id = 1228
// module chunks = 16